import { Component, OnInit } from '@angular/core';
import { Video, VideoSection } from '@emi/shared/models';

import * as videoData from '../../../../../assets/src/lib/help-resources/help-videos.json';
@Component({
    selector: 'via-video-tutorials',
    templateUrl: './video-tutorials.component.html',
    styleUrls: ['./video-tutorials.component.scss'],
})
export class VideoTutorialsComponent implements OnInit {
    public videoSections: VideoSection[] = [];
    public activeVideo: Video;

    public ngOnInit(): void {
        this.getVideoContent();
    }

    public setVideo(video: Video): void {
        this.activeVideo = video;
    }

    private getVideoContent() {
        let parsedVideoSection: VideoSection[] = JSON.parse(JSON.stringify(videoData));

        for (var index = 0; index < parsedVideoSection.length; index++) {
            let videoSection = parsedVideoSection[index];
            let sectionVideos = videoSection.videos.map(
                (sectionVideo) => new Video(sectionVideo.id, sectionVideo.displayOrder, sectionVideo.title, sectionVideo.url)
            );

            this.videoSections.push(new VideoSection(videoSection.id, videoSection.name, sectionVideos, videoSection.displayOrder));
            this.activeVideo = this.videoSections[0].videos[0];
        }
    }
}
